
import { defineComponent, PropType } from 'vue';
import { ClientConstants } from './../client.constants';

declare let app: any;

export interface BreadCrumb {
  text: string;
  href?: string;
  id?: string;
}

export type BreadCrumbs = Array<BreadCrumb>;

export default defineComponent({
  name: 'BreadCrumbs ',
  props: {
    linkList: { type: Array as PropType<BreadCrumbs>, required: true },
    showActionLinks: { type: Boolean, default: false, required: false }
  },
  data: () => {
    return {
      clientConstants: ClientConstants,
      actionsList: [
        {
          text: ClientConstants.PRINT,
          href: `${app?.hostUrl}${app?.fractionalCDsPrintPath}`,
          iconLeft: 'action__print'
        },
        {
          text: ClientConstants.EMAIL,
          href: `${app?.hostUrl}${app?.fractionalCDsEmailPath}`,
          iconLeft: 'action__email'
        },
        {
          text: ClientConstants.SHARE,
          href: `${app?.hostUrl}${app?.fractionalCDsSharePath}`,
          iconLeft: 'action__share'
        }
      ]
    };
  }
});
